import * as React from 'react';
import { OffersTenMinutes } from '../../components/OffersTenMinutes';
import { Advantages } from '../../components/Advantages';
import { Steps } from '../../components/Steps';
import { BanksListContainer } from '../../containers/BanksListContainer';
import { ShowCaseContainer } from '../../containers/ShowCaseContainer';
import { SubmitPhoneFormContainer } from '../../containers/SubmitPhoneFormContainer';
import { Notes } from '../../components/Notes';
import { ContactUs } from '../../components/ContactUs';
import { InterestRateContainer } from '../../containers/InterestRateContainer/InterestRateContainer';

export const MainPage = () => {
  return (
    <>
      <SubmitPhoneFormContainer Form={ShowCaseContainer} label="main_login_block" />
      <BanksListContainer />
      <Steps />
      <OffersTenMinutes />
      <InterestRateContainer />
      <Advantages />
      <ContactUs />
      <Notes />
    </>
  );
};
